module.exports = __webpack_public_path__ + "img/TSNY_Logo_Full.82632f4f.svg";